<form [formGroup]="form">
  <label class="form-field-label" i18n>Reservations will be auto-assigned</label>
  <mat-radio-group class="d-flex flex-column" formControlName="auto_assign">
    <mat-radio-button value="created">At reservation creation</mat-radio-button>
  </mat-radio-group>
</form>

<div class="alert alert-secondary-info mt-3">
  <i class="fal fa-info-circle alert-icon"></i>
  <div class="alert-content" i18n>
    Reservations will be currently auto-assigned to subunits at creation based on a predefined order. Order and priority
    can be adjusted later in the Multi-Unit Settings within the main unit’s rental details.
  </div>
</div>
